import { useEffect, useState } from "react";
import Permissions from "../../components/Permissions/Permissions";

const IphoneStandAlone = (props) => {
  const { onShowMainContent, eventId, needsPermission, appIcon } = props;
  const [permissionsGranted, setPermissionsGranted] = useState(
    !needsPermission
  );
  const [notificationPermission, setNotificationPermission] =
    useState("prompt");
  const handlePermissionsGranted = () => {
    setPermissionsGranted(true);
    onShowMainContent();
  };

  useEffect(() => {
    if (needsPermission) {
      const checkPermissions = async () => {
        // Check Notification Permission
        if ("Notification" in window) {
          setNotificationPermission(Notification.permission);
        }
      };

      checkPermissions();
    } else {
      setPermissionsGranted(true);
      onShowMainContent();
    }
  }, [needsPermission]);

  return (
    <>
      {!permissionsGranted ? (
        <Permissions
          onPermissionsGranted={handlePermissionsGranted}
          eventId={eventId}
          handleContinueWithoutNotifications={handlePermissionsGranted}
          needsPermission={needsPermission}
          appIcon={appIcon}
        />
      ) : null}
    </>
  );
};

export default IphoneStandAlone;
